import React from 'react';

import Radio from '../../atoms/inputField/Radio';
import Labelize from './Labelize';
import Box from '../../atoms/Box';

import { string, arrayOf, shape } from 'prop-types';
import { inputPropTypesObject } from '../../elements/form/decorators';

const RadioGroup = React.forwardRef(({ label, name, radioParams, errorMessage, ...input }, ref) => (
  <Labelize label={label} errorMessage={errorMessage} inputName={name}>
    <Box pt="28px" display="flex" flexDirection="column" alignItems="flex-start">
      {radioParams.map(({ label, value }) => (
        <Radio key={label} name={name} label={label} value={value} {...input} ref={ref} />
      ))}
    </Box>
  </Labelize>
));

RadioGroup.propTypes = {
  ...inputPropTypesObject,
  label: string,
  radioParams: arrayOf(
    shape({
      label: string,
      value: string
    })
  ),
  errorMessage: string
};

export default RadioGroup;
